import Vue from 'vue'
import { Slide } from 'vue-carousel'
import Carousel from '../../components/core/Carousel'
import DownloadGuide from '../../views/downloadGuide/DownloadGuide'
import initMobileGallery from '../common/initMobileGallery'
import TopNavTrigger from '../../components/core/TopNavTrigger'
import DestinationCTA from '../../components/Country/DestinationCTA'
import Responsive from '../../components/core/Responsive'
import SearchParamsDesktop from '../../components/Search/SearchParamsDesktop'
import FeaturedReview from '../../components/FeaturedReview'
import CurrencyContext from '../../components/core/CurrencyContext'

$(document).ready(function() {
  initMobileGallery()

  const stickyHeader = $('.destination-secondary-nav')
  const footerNav = $('.destination-footer-nav')

  stickyHeader.stickySidebar({
    topSpacing: 0,
    bottomSpacing: 50,
    containerSelector: '.sticky-nav-container',
    innerWrapperSelector: '.sidebar__inner'
  })

  const isMobile = window.matchMedia('only screen and (max-width: 1200px)').matches

  if (isMobile) {
    stickyHeader.get(0).addEventListener('affixed.top.stickySidebar', function () {
      pushUpTrengoChat(true)
      footerNav.removeClass('is-hidden')
    })

    stickyHeader.get(0).addEventListener('affixed.container-bottom.stickySidebar', function () {
      pushUpTrengoChat(false)
      footerNav.addClass('is-hidden')
    })

    stickyHeader.get(0).addEventListener('affixed.static.stickySidebar', function () {
      pushUpTrengoChat(false)
      footerNav.addClass('is-hidden')
    })
  }

  if ($('#destination-sticky-nav').length) {
    setTimeout(() => {
      $('#destination-sticky-nav').navpoints()
    }, 2000)
  }
})

Vue.component('top-nav-trigger', TopNavTrigger)
Vue.component('carousel', Carousel)
Vue.component('v-slide', Slide)
Vue.component('download-guide', DownloadGuide)
Vue.component('destination-cta', DestinationCTA)
Vue.component('responsive', Responsive)
Vue.component('search-params-desktop', SearchParamsDesktop)
Vue.component('featured-review', FeaturedReview)
Vue.component('currency-context', CurrencyContext)

const apps = document.querySelectorAll('.vue-app')

Array.prototype.forEach.call(apps, el => new Vue({
  el,
  template: el.innerHTML
}))
